/**
 * baseCompareVersion: 比较版本
 * @param
 * @example
 * ```js
 *  const version = compareVersion()
 *  console.log(version) // '2.0.0'
 * ```
 */
const baseCompareVersion = (preVersion, lastVersion) => {
    const sources = preVersion.split('.');
    const dests = lastVersion.split('.');
    const maxLength = Math.max(sources.length, dests.length);
    let result = 0;
    for (let i = 0; i < maxLength; i++) {
        let preValue = sources.length > i ? sources[i] : '0';
        let preNum = isNaN(Number(preValue))
            ? preValue.charCodeAt(0)
            : Number(preValue);
        let lastValue = dests.length > i ? dests[i] : '0';
        let lastNum = isNaN(Number(lastValue))
            ? lastValue.charCodeAt(0)
            : Number(lastValue);
        if (preNum < lastNum) {
            result = -1;
            break;
        }
        else if (preNum > lastNum) {
            result = 1;
            break;
        }
    }
    return result;
};
export { baseCompareVersion };
